import React, { useEffect } from "react";
import { BrowserRouter, Link, Route, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import useNavigateToSection from "../hooks/useNavigateToSection";

const Work4: React.FC = () => {
  window.scrollTo(0, 0);
  const navigateToSection = useNavigateToSection();
  return (
    <main className="content pt-40">
      <Container>
        <article className="article mx-auto">
          <div className="article-container">
            <h2 className="article-title text-center text-3xl font-bold mb-4">
              Hackathon Project: Chat Learning tool
            </h2>
            <div className="article-body grid gap-y-5">
              <img
                src="/hackathon.jpg"
                alt=""
                className="mb-4 max-h-[50rem] object-contain"
              />
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: 0,
                  paddingTop: "56.2500%",
                  paddingBottom: 0,
                  boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
                  marginTop: "1.6em",
                  marginBottom: "0.9em",
                  overflow: "hidden",
                  borderRadius: "8px",
                  willChange: "transform",
                }}
              >
                <iframe
                  loading="lazy"
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    border: "none",
                    padding: 0,
                    margin: 0,
                  }}
                  src="https://www.canva.com/design/DAGnA29JGyU/Z2rAST_KHtJ_HNY6_meFOA/view?embed"
                  allow="fullscreen"
                ></iframe>
              </div>
              <a
                href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAGnA29JGyU&#x2F;Z2rAST_KHtJ_HNY6_meFOA&#x2F;view?utm_content=DAGnA29JGyU&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
                target="_blank"
                rel="noopener"
              >
                Team10進捗報告
              </a>
              <ul className="flex gap-x-3 flex-wrap gap-y-2">
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Javascript
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  React
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Python
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  FastAPI
                </li>
              </ul>
              <div>
                <h3 className="font-bold mb-2 text-xl">Github Repo</h3>
                <p className="mb-4">
                  <a
                    href="https://github.com/Mizuki-Kawabe/chatbot-hackathon/tree/main"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://github.com/Mizuki-Kawabe/chatbot-hackathon/tree/main
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">My role</h3>
                <p className="mb-4">Coding</p>
              </div>
            </div>

            <button
              className="font-bold block mx-auto my-10 h-color"
              onClick={() => navigateToSection("works")}
            >
              ← Go back to Works
            </button>
          </div>
        </article>
      </Container>
    </main>
  );
};

export default Work4;
